import React, { useState } from 'react';
import { FaBookOpenReader, FaMinus, FaPlus } from 'react-icons/fa6';
import Navbar from '../components/body_nav';
import './style.css';

function About() {
  const [activeTab, setactivetab] = useState('education');
  const education_data = [
    {
      institute: 'SMIU',
      degree: "Bachelor's Degree In Progress",
      duration: '2021 - Present',
      description: `<p>At SMIU, I am currently pursuing a Bachelor's degree in Computer Science. My studies focus on a wide range of computer science disciplines, including programming, software development, and data structures. I have also worked on various projects that have enhanced my understanding and practical skills in the field.</p>`,
    },
    {
      institute: 'Jawan-Pakistan',
      degree: 'MERN Stack Development',
      duration: '2022',
      description: `<p>Completed a comprehensive MERN Stack Development course at Jawan-Pakistan. The course covered MongoDB, Express.js, React.js, and Node.js, providing hands-on experience in building full-stack web applications.</p>`,
    },
    {
      institute: 'Sm Science College',
      degree: 'Intermediate in Pre-Engineering',
      duration: '2018 - 2020',
      description: `<p>Studied Intermediate in Pre-Engineering at Sm Science College, where I focused on core subjects including Physics, Chemistry, and Mathematics. This foundation in engineering principles has been crucial in my transition to computer science and software development.</p>`,
    },
  ];

  const experience_data = [
    {
      organization: 'kaj Consultancy',
      position: 'Front End Developer - Front End Web Development',
      duration: 'September 2023 - Present',
      description: `<div>
    <div>
  
      <p>
        As a Front End Developer at kaj Consultancy, I meticulously craft visually stunning and highly interactive user interfaces to enhance the overall user experience. My role primarily focuses on translating design concepts into seamless, responsive web applications. My key responsibilities include:
      </p><br>
      <ul>
        <li><strong>Design Translation</strong>: Translating design concepts into seamless, responsive web applications, utilizing cutting-edge technologies for an optimal user interface.</li>
        <li><strong>Interactive UI Development</strong>: Creating highly interactive user interfaces that are visually appealing and user-friendly.</li>
        <li><strong>Responsive Design</strong>: Ensuring that applications are responsive and work seamlessly across various devices and screen sizes.</li>
      </ul>
      <p>
        Through these responsibilities, I have developed a keen eye for design, honed my front-end development skills, and contributed to the creation of high-quality, user-centric web applications.
      </p>
    </div>
  </div>
  `,
    },
    {
      organization: 'Jawan Pakistan',
      position: 'Assistant Teacher - MERN Stack Development',
      duration: 'December 2022 - August 2023',
      description: `<div>
    <div>
  
      <p>
        As an Assistant Teacher at Jawan Pakistan, I assisted in conducting MERN Stack development training sessions for students, providing guidance on MongoDB, Express.js, React.js, and Node.js. My key responsibilities included:
      </p><br>
      <ul>
        <li><strong>Training Sessions</strong>: Assisting in conducting MERN Stack development training sessions for students.</li>
        <li><strong>Technical Guidance</strong>: Providing technical guidance on MongoDB, Express.js, React.js, and Node.js.</li>
        <li><strong>Student Support</strong>: Supporting students in problem-solving, debugging, and troubleshooting their MERN Stack projects.</li>
      </ul>
      <p>
        Through these responsibilities, I have contributed to a collaborative learning environment and helped students build a strong foundation in MERN Stack development.
      </p>
    </div>
  </div>
  `,
    },
    {
      organization: 'Matrix Tech Software Solutions',
      position: 'MERN Stack Developer',
      duration: 'December 2022 - December 2023',
      description: `<div>
    <div>
  
      <p>
        As a MERN Stack Developer at Matrix Tech Software Solutions, I developed and maintained full-stack web applications using the MERN (MongoDB, Express.js, React.js, Node.js) stack. My key responsibilities included:
      </p><br>
      <ul>
        <li><strong>Application Development</strong>: Developing and maintaining full-stack web applications using the MERN stack.</li>
        <li><strong>Collaboration</strong>: Collaborating with cross-functional teams to gather project requirements, translate them into technical specifications, and implement responsive front-end interfaces with React.js.</li>
        <li><strong>API Integration</strong>: Integrating RESTful APIs for seamless communication between components.</li>
      </ul>
      <p>
        Through these responsibilities, I have gained extensive experience in full-stack development and contributed to the successful delivery of web applications for clients.
      </p>
    </div>
  </div>
  `,
    },
    {
      organization: 'Matrix Tech Software Solutions',
      position: 'React Native Developer',
      duration: 'December 2022 - December 2023',
      description: `<div>
    <div>
  
      <p>
        As a React Native Developer at Matrix Tech Software Solutions, I crafted captivating cross-platform apps, merging native power with a unified codebase for an enhanced user experience. My key responsibilities included:
      </p><br>
      <ul>
        <li><strong>Cross-Platform App Development</strong>: Crafting captivating cross-platform apps using React Native, merging native power with a unified codebase.</li>
        <li><strong>Collaboration</strong>: Collaborating with teams to transform project visions into technical specs, focusing on responsive React.js interfaces and integrating RESTful APIs for communication between front-end and back-end realms.</li>
      </ul>
      <p>
        Through these responsibilities, I have refined my React Native skills and played a key role in delivering high-quality mobile applications.
      </p>
    </div>
  </div>
  `,
    },
  ];

  // const skill_data = [
  //   { title: 'Python', level: '98' },
  //   { title: 'Java', level: '90%' },
  //   { title: 'HTML', level: '98%' },
  //   { title: 'CSS', level: '90%' },
  // ];
  const skill_data = [
    { title: 'HTML', level: '98%' },
    { title: 'CSS', level: '95%' },
    { title: 'JavaScript', level: '90%' },
    { title: 'TypeScript', level: '85%' },
    { title: 'React', level: '90%' },
    { title: 'ViteJs', level: '80%' },
    { title: 'NextJs', level: '82%' },
    { title: 'Tailwind', level: '87%' },
    { title: 'Material UI', level: '83%' },
    { title: 'Bootstrap', level: '85%' },
    { title: 'NodeJS', level: '88%' },
    { title: 'ExpressJS', level: '86%' },
    { title: 'NestJs', level: '80%' },
    { title: 'RestApi', level: '90%' },
    { title: 'MongoDB', level: '85%' },
    { title: 'SQLite', level: '80%' },
    { title: 'Firebase', level: '78%' },
    { title: 'GitHub', level: '92%' },
    { title: 'MonoRepo', level: '75%' },
    { title: 'Pnpm', level: '70%' },
    { title: 'Npm', level: '85%' },
  ];

  const handleactivetab = (tabtitle) => {
    setactivetab(tabtitle);
  };
  return (
    <>
      <Navbar title={'About'} icon={<FaBookOpenReader />} />

      <div className="md:overflow-y-auto mb-4 pr-4">
        {activeTab !== 'education' && (
          <div className="flex items-center justify-between bg-primary rounded px-2 my-2">
            <h4 class="my-4 pr-2 text-xl font-sans font-bold text-darkgrey w-fit">
              Education
            </h4>

            <div
              className="bg-secondary rounded p-2 text-lightgrey "
              onClick={() => handleactivetab('education')}
            >
              <FaPlus className=" " />
            </div>
          </div>
        )}

        {activeTab === 'education' && (
          <>
            <div className="flex items-center justify-between">
              <h4 class="my-4 pr-2 text-xl font-sans font-bold text-darkgrey border-b-2 w-fit">
                Education
              </h4>

              <div
                className="bg-primary rounded mr-2 p-2 text-lightgrey"
                onClick={() => handleactivetab('')}
              >
                <FaMinus className=" " />
              </div>
            </div>

            {/* <div class=" gap-2">
              {education_data.map((item, index) => (
                <div class="flex mb-2 before:bg-lightgrey before:w-1 before:mt-2">
                  <div class=" flex flex-col items-center ml-2 w-44 overflow-ellipsis">
                    <h4 class="text-xl font-bold text-lightgrey dark:text-white">
                      {item.degree}
                    </h4>
                    <p class="font-dm text-sm font-medium text-darkgrey">
                      {item.duration}
                    </p>
                  </div>
                  <div class=" ml-6 flex w-auto flex-col ">
                    <h4 class="text-xl font-bold text-lightgrey dark:text-white">
                      {item.institute}
                    </h4>
                    <div
                      className="font-dm text-sm font-medium text-darkgrey"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </div>
                </div>
              ))}
            </div> */}
            <div class=" pr-3">
              {education_data.map((item, index) => (
                <div class="mb-2 eduex heading before:bg-lightgrey before:w-2 before:mt-2">
                  <div class="flex items-center flex-wrap mb-[2px] text-lightgrey text-xl font-bold gap-2">
                    <h4 class="">{item.degree}</h4>
                    <span className="text-xl"> - </span>
                    <h4 class="">{item.institute}</h4>
                  </div>
                  <div class=" flex w-auto flex-col ">
                    <h3 class="text-sm font-medium text-seagreen mb-2">
                      {item.duration}
                    </h3>
                    <div
                      className="font-dm text-sm font-medium text-darkgrey"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {activeTab !== 'experience' && (
          <div className="flex items-center justify-between bg-primary rounded px-2 my-2">
            <h4 class="my-4 pr-2 text-xl font-sans font-bold text-darkgrey w-fit">
              Experience
            </h4>

            <div
              className="bg-secondary rounded p-2 text-lightgrey"
              onClick={() => handleactivetab('experience')}
            >
              <FaPlus className=" " />
            </div>
          </div>
        )}

        {activeTab === 'experience' && (
          <>
            <div className="flex items-center justify-between ">
              <h4 class="my-4 pr-2 text-xl font-sans font-bold text-darkgrey border-b-2 w-fit">
                Experience
              </h4>
              <div
                className="bg-primary rounded mr-2 p-2 text-lightgrey"
                onClick={() => handleactivetab('')}
              >
                <FaMinus className=" " />
              </div>
            </div>
            {/* 
            <div class=" gap-2">
              {experience_data.map((item, index) => (
                <div class="flex mb-2 before:bg-lightgrey before:w-1 before:mt-2">
                  <div class=" flex flex-col items-center ml-2 w-44 overflow-ellipsis">
                    <h4 class="text-xl font-bold text-lightgrey dark:text-white">
                      {item.position}
                    </h4>
                    <p class="font-dm text-sm font-medium text-darkgrey">
                      {item.duration}
                    </p>
                  </div>
                  <div class=" ml-6 flex w-auto flex-col ">
                    <h4 class="text-xl font-bold text-lightgrey dark:text-white">
                      {item.organization}
                    </h4>
                    <div
                      className="font-dm text-sm font-medium text-darkgrey"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </div>
                </div>
              ))}
            </div> */}

            <div class="pr-3">
              {experience_data.map((item, index) => (
                <div class="mb-2 eduex heading before:bg-lightgrey before:w-2 before:mt-2">
                  <div class="flex items-center flex-wrap mb-[2px] text-lightgrey text-xl font-bold gap-2">
                    <h4 class="">{item.position}</h4>
                    <span className="text-xl"> - </span>
                    <h4 class="">{item.organization}</h4>
                  </div>
                  <div class=" flex w-auto flex-col ">
                    <h3 class="text-sm font-medium text-seagreen mb-2">
                      {item.duration}
                    </h3>
                    <div
                      className="font-dm text-sm font-medium text-darkgrey"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        <h4 class="text-xl text-darkgrey font-bold py-4">Skills</h4>

        <div className="flex flex-wrap gap-4">
          {skill_data.map((item, index) => (
            <div
              key={index}
              className="w-full md:w-[48%] flex flex-col space-y-1"
            >
              <div className="flex justify-between items-center">
                <h4 className="text-lightgrey">{item.title}</h4>
              </div>
              <div className="w-full h-3 bg-darkgrey rounded-full overflow-hidden">
                <div
                  className="h-full bg-seagreen rounded-full"
                  style={{ width: item.level }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default About;
